import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthStorageService {
  private readonly userIdKey = 'userId';
  private readonly accessTokenKey = 'accessToken';

  constructor() {
  }

  setUserId(userId: number): void {
    localStorage.setItem(this.userIdKey, userId.toString());
  }

  getUserId(): string | null {
    return localStorage.getItem(this.userIdKey);
  }

  removeUserId(): void {
    localStorage.removeItem(this.userIdKey);
  }

  setAccessToken(accessToken: string): void {
    localStorage.setItem(this.accessTokenKey, accessToken);
  }

  getAccessToken(): string | null {
    return localStorage.getItem(this.accessTokenKey);
  }

  removeAccessToken(): void {
    localStorage.removeItem(this.accessTokenKey);
  }

  clearAll(): void {
    this.removeUserId();
    this.removeAccessToken();
  }
}
